'use strict';

import { Group } from 'three';
import { projectMode, threeJsVariables } from '../../settings';

export class District {
    #sortedBuildings = [];
    #isOneFloorBuildings = [];

    constructor () {
        this.buildings = {};
        this.activeBuilding = null;
        this.oneMeshModel = null;
    }

    addOneMeshModel(model) {
        const group = new Group();
        group.name = model.name;

        group.position.set(model.parent.position.x, model.parent.position.y, model.parent.position.z);
        group.scale.set(model.parent.scale.x, model.parent.scale.y, model.parent.scale.z);
        group.rotation.set(model.parent.rotation.x, model.parent.rotation.y, model.parent.rotation.z);


        if (model.userData.groups) {
            model.geometry.groups.push(...model.userData.groups);
        }

        model.geometry.computeBoundsTree();
        model.layers.enable(1);
        group.add(model);
        this.oneMeshModel = group;

        return group;
    }

    addBuilding(name,building){
        this.buildings[name] = building;
        this.#sortedBuildings = Object.values(this.buildings);
    }
    
    sortBuildings() {
        const data = Object.values(this.buildings);
        
        const availableBuildings = data.filter(building => Object.keys(building.info).length);
        const disabledBuildings = data.filter(building => Object.keys(building.info).length === 0);
    
        const lots = [...new Set(availableBuildings.map(building => building.info.buildingLot))];
        if (lots.length > 1 && config.features.cluster?.active) {
            lots.sort((prev,next) => {
                const prevLot = parseFloat(prev);
                const nextLot = parseFloat(next);
                if (!isNaN(prevLot) && !isNaN(nextLot)) {
                    return prevLot - nextLot;
                } else {
                    return 1;
                }
            });
            const sorted = [];
            lots.forEach(lot => {
                const buildingsFromLot = data.filter(building => building.info.buildingLot === lot);
                buildingsFromLot.sort((prev,next) => prev.info.buildingName.localeCompare(next.info.buildingName,'he',{numeric: true}));
                sorted.push(...buildingsFromLot);
            });
            sorted.push(...disabledBuildings);
            this.#sortedBuildings = sorted;
        } else {
            availableBuildings.sort((prev,next) => prev.info.buildingName.localeCompare(next.info.buildingName,'he',{numeric: true}));
            this.#sortedBuildings = [...availableBuildings,...disabledBuildings];
        }
    }

    activateBuilding(name){
        if (this.activeBuilding && this.activeBuilding.isActive){
            this.activeBuilding.deactivate();
            this.activeBuilding = null;
        }

        this.buildings[name].activate();
        this.activeBuilding = this.buildings[name];
    }

    deactivateBuilding(){
        if (this.activeBuilding && this.activeBuilding.isActive){
            this.activeBuilding.deactivate();
            this.activeBuilding = null;
        }
    }

    getActiveBuilding(){
        return this.activeBuilding;
    }

    getActiveBuildingAmountOfFloors() {
        return new Set(this.activeBuilding?.floorSliderNumbers).size || 0;
    }

    getDeactivatedBuildings(){
        return this.getBuildingsArray().filter(building => !building.isActive);
    }

    getBuilding(name){
        return this.buildings[name];
    }

    getBuildingsArray(){
        return this.#sortedBuildings;
    }

    getBuildingsInfoLength(){
         return  this.getBuildingsArray()
            .map(building => Object.keys(building.info).length > 0)
            .filter(info => info === true).length;
    }
    
    isUsedBuilding(name) {
        const available = config.features.activeBuildings;
        if (!available)
            return true;
        
        return available.includes(name);
    }

    isOneFloorBuilding(engineId) {
        if (projectMode.LiteMode.isActive()) {
            if (this.#isOneFloorBuildings.length === 0) {
                for (const building in this.buildings) {
                    const floors = new Set();
                    this.buildings[building].apartments.forEach(apartment => {
                        floors.add(apartment.userData.floor);
                    });
                    if (floors.size < 2) {
                        const currentBuildingEngineId = this.buildings?.[building]?.info?.crm_data?.[0]?.buildingEngineId;
                        currentBuildingEngineId && this.#isOneFloorBuildings.push(currentBuildingEngineId);
                    }
                }

                if (this.#isOneFloorBuildings.length === 0)
                    this.#isOneFloorBuildings.push('empty');
            }

            return this.#isOneFloorBuildings.includes(engineId);
        } else {
            return this.getActiveBuildingAmountOfFloors() <= 1;
        }
    }
}
